<template>
    <div>
        <vue-headful
                title="Falk Huth | Ausbildungsdaten"
                description="Daten über den Ausbildungsverlauf von Falk Huth"
        />
        <md-card md-with-hover>
            <md-ripple>
                <md-card-header>
                    <div class="md-title">Ausbildungsdaten</div>
                    <div class="md-subhead">
                        und erlangte Abschlüsse
                    </div>
                </md-card-header>

                <md-card-content>
                    <div class="md-layout">
                        <div class="md-layout-item md-size-45 md-xsmall-size-100">
                            <md-subheader class="md-primary">
                                <md-icon class="icon-davor md-primary">date_range</md-icon>
                                Master-Abschluss für März 2021 berufsbegleitend angestrebt
                            </md-subheader>
                            <div class="md-body-2">
                                MBA-Studiengang &quot;Management von Bildungseinrichtungen&quot;
                            </div>
                            <div class="md-body-1">
                                <a href="http://www.uni-halle.de" target="_blank">Martin-Luther-Universität
                                    Halle-Wittenberg</a>
                            </div>
                            <div class="md-body-1 detail-space">
                                begonnen im April 2019
                            </div>
                        </div>
                        <div class="md-layout-item md-size-5 md-xsmall-hide"></div>
                        <div class="md-layout-item md-size-45 md-xsmall-size-100">
                            <md-subheader class="md-primary">
                                <md-icon class="icon-davor md-primary">date_range</md-icon>
                                FH-Diplom am 08.09.2009, Gesamtprädikat: Gut
                            </md-subheader>
                            <div class="md-body-2">
                                Diplom-Wirtschaftsinformatiker (FH)
                            </div>
                            <div class="md-body-1">
                                <a href="https://www.fh-zwickau.de" target="_blank">Westsächsische Hochschule
                                Zwickau</a> - University of Applied Sciences
                            </div>
                            <div class="md-body-1 detail-space">
                                Aufbaufernstudium mit Diplomarbeits-Thema:<br/>
                                <i>&quot;Erhebung der Anforderungen und Erkenntnisse aus der Einführung eines
                                    CRM-Systems am Beispiel der itCampus Software- und Systemhaus GmbH&quot;</i>
                            </div>
                        </div>
                    </div>
                    <div class="md-layout">
                        <div class="md-layout-item md-size-45 md-xsmall-size-100">
                            <md-divider></md-divider>
                            <md-subheader class="md-primary">
                                <md-icon class="icon-davor md-primary">date_range</md-icon>
                                BA-Diplom am 25.10.2002, Note: 1,8
                            </md-subheader>
                            <div class="md-body-2">
                                Diplom-Wirtschaftsinformatiker (BA)
                            </div>
                            <div class="md-body-1">
                                <a href="http://www.ba-glauchau.de" target="_blank">Staatliche Studienakademie
                                Glauchau</a> (Berufsakademie Sachsen)
                            </div>
                            <div class="md-body-1 detail-space">
                                Duales Studium über sechs Semester mit Praxisphasen bei der
                                itCampus Software- und Systemhaus GmbH Leipzig,
                                Diplomarbeits-Thema:<br/>
                                <i>&quot;Konzeption eines shared-browsing-gestützten Hilfesystems
                                    im Support- und Servicebereich&quot;</i>
                            </div>
                        </div>
                        <div class="md-layout-item md-size-5 md-xsmall-hide"></div>
                        <div class="md-layout-item md-size-45 md-xsmall-size-100">
                            <md-divider></md-divider>
                            <md-subheader class="md-primary">
                                <md-icon class="icon-davor md-primary">date_range</md-icon>
                                Vordiplom am 03.06.1996
                            </md-subheader>
                            <div class="md-body-2">
                                Studium Wirtschaftsinformatik bis September 1999
                            </div>
                            <div class="md-body-1">
                                <a href="http://www.uni-halle.de" target="_blank">Martin-Luther-Universität
                                    Halle-Wittenberg</a>
                            </div>
                            <div class="md-body-1 detail-space">
                                Cambridge First Certificate in English (FCE) im Dezember 1995
                            </div>
                        </div>
                    </div>
                    <div class="md-layout">
                        <div class="md-layout-item md-size-45 md-xsmall-size-100">
                            <md-divider></md-divider>
                            <md-subheader class="md-primary">
                                <md-icon class="icon-davor md-primary">date_range</md-icon>
                                Abitur am 03.07.1993, Note: 1,7
                            </md-subheader>
                            <div class="md-body-2">
                                Landesgymnasium in Halle (Saale)
                            </div>
                            <div class="md-body-1">
                                <a href="http://www.latina-halle.de" target="_blank">LATINA
                                August Hermann Francke</a>
                            </div>
                            <div class="md-body-1 detail-space">
                                Spezialklasse für Neusprachen (Russisch, Englisch, Französisch),<br/>
                                besondere Leistungen in Mathematik und Physik
                            </div>
                        </div>
                    </div>
                </md-card-content>
            </md-ripple>
        </md-card>
    </div>
</template>

<script>
    export default {
        name: "Ausbildungsdaten"
    }
</script>

<style lang="scss" scoped>
    .md-subheader {
        padding-left: 0!important;
    }
    .icon-davor {
        margin-left: 0px;
        margin-right: 5px;
    }
    .detail-space {
        margin-top: 10px;
        margin-bottom: 10px;
    }
</style>
